<template>
  <div class="pt-card-container stoppoint" v-loading="loading">
    <div class="pt-card-attributes">
      <component
        v-for="config in attributes"
        :key="config.id"
        :is="`card-${config.type}`"
        :feature="feature"
        :config="config"
      />
    </div>
    <card-buttons
      :feature="feature"
      :save="save"
      :cancel="cancel"
      :required="requiredProps"
    />
  </div>
</template>

<script>
import { clearAllHelpers } from "@/libs/map-draw/helpers";
import CardInput from "./controls/card-input";
import CardSwitch from "./controls/card-switch";
import CardCheckboxGroup from "./controls/card-checkbox-group";
import CardButtons from "./controls/card-buttons";
import { getSpAttributes } from "./config";

const removedProps = ["transport_systems"];

export default {
  props: ["mapgl", "draw", "state", "close-card"],
  components: {
    CardInput,
    CardSwitch,
    CardCheckboxGroup,
    CardButtons
  },
  data() {
    return {
      loading: false,
      feature: {
        id: null,
        name: "",
        is_active: true,
        transport_type: [1],
        on_demand: false,
        distance_class: [1],
        transport_systems: []
      },
      requiredProps: ["name"],
      attributes: getSpAttributes(this.$store.state.publicTransport.model.ids)
    };
  },
  watch: {
    "$store.state.publicTransport.activeCardId": {
      handler: function(val) {
        if (!val) return;
        this.getInfo();
      }
    }
  },
  methods: {
    getInfo() {
      const { activeObject, mode } = this.state;
      const { properties } = activeObject;
      const { id } = properties;

      if (mode === "create") return;

      if (!id) {
        this.setInitialValues(properties);
      } else {
        this.getObjectData(id);
      }
    },
    async getObjectData(id) {
      try {
        this.loading = true;
        const { ids } = this.$store.state.publicTransport.model;
        const config = {
          where: [
            {
              field: "id",
              op: "=",
              value: id
            }
          ],
          include: {
            transport_systems: {}
          }
        };
        const url = `objectInfo/${ids["stop_points"]}?config=${JSON.stringify(
          config
        )}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.setInitialValues(data[id]);

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    setInitialValues(initial) {
      Object.keys(this.feature).forEach(key =>
        this.$set(this.feature, key, initial[key])
      );
    },
    cancel() {
      const { activeObject, mode } = this.state;
      if (mode === "create") this.draw.delete(activeObject.id);
      if (mode === "edit") this.draw.changeMode("simple_select");

      clearAllHelpers(this.mapgl);
      this.closeCard();
    },
    save() {
      const {
        activeObject,
        editingCallback,
        creatingCallback,
        mode
      } = this.state;
      const callback = mode === "create" ? creatingCallback : editingCallback;

      Object.keys(this.feature)
        .filter(key => removedProps.indexOf(key) === -1)
        .forEach(key => {
          activeObject.setProperty(key, this.feature[key]);
        });

      callback(activeObject);
      this.closeCard();
    }
  },
  created() {
    this.getInfo();
  }
};
</script>

<style></style>
